import React, { useState, useEffect } from 'react';
import './cookiebanner.css';

const STORAGE_KEY = 'lcd_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="banner" aria-label="Cookie consent">
      <div className="cookie-banner__inner container">
        <div className="cookie-banner__content">
          <p className="cookie-banner__text">
            We use cookies to improve your experience and analyse site traffic. By clicking "Accept", you consent to our use of cookies. See our{' '}
            <button className="cookie-banner__link" onClick={decline}>Cookie Policy</button> for details.
          </p>
        </div>
        <div className="cookie-banner__actions">
          <button className="btn btn--primary btn--sm" onClick={accept}>Accept</button>
          <button className="btn btn--secondary btn--sm" onClick={decline}>Decline</button>
        </div>
      </div>
    </div>
  );
}
